function setupSwatchLabelHover() {
  // Bind to the document level once (delegated)
  document.removeEventListener('mouseover', swatchLabelMouseOver);
  document.removeEventListener('mouseout', swatchLabelMouseOut);

  document.addEventListener('mouseover', swatchLabelMouseOver);
  document.addEventListener('mouseout', swatchLabelMouseOut);
}

function swatchLabelMouseOver(e) {
  const swatch = e.target.closest('.swatch-label-hover .block-swatch__item');
  if (!swatch) return;

  const container = swatch.closest('.swatch-label-update');
  const optionText = swatch.getAttribute('data-option-text');
  const selectedTextElement = container?.querySelector('.selected-option-text');

  if (selectedTextElement && optionText) {
    selectedTextElement.setAttribute('data-current-hover-text', selectedTextElement.textContent);
    selectedTextElement.textContent = optionText;
  }
}

function swatchLabelMouseOut(e) {
  const swatch = e.target.closest('.swatch-label-hover .block-swatch__item');
  if (!swatch) return;

  const container = swatch.closest('.swatch-label-update');
  const selectedTextElement = container?.querySelector('.selected-option-text');

  const initialText = selectedTextElement?.getAttribute('data-initial-option-text');
  const fallbackText = selectedTextElement?.getAttribute('data-current-hover-text');

  if (selectedTextElement) {
    selectedTextElement.textContent = initialText || fallbackText || '';
  }
}

function setupRingSizeInquiryDelegated() {
  const modal = document.getElementById('ringSizeInquiryModal');
  const closeModalBtn = modal?.querySelector('.modal-close');
  const overlay = modal?.querySelector('.modal-overlay');

  if (!modal) return;

  // One delegated listener for Add to Cart clicks
  document.addEventListener('click', function (e) {
    const addToCartBtn = e.target.closest('#AddToCart');
    if (!addToCartBtn) return;

    let selectedOption = null;
    const dropdownForSize = document.querySelector('.dropdown-for-size');
    if (dropdownForSize) {
      selectedOption = dropdownForSize.querySelector(
        '.combo-box__option-list .combo-box__option-item[aria-selected="true"]'
      );
    } else {
      const form = document.querySelector('form[action="/cart/add"]');
      selectedOption = form?.querySelector(
        '.combo-box__option-list .combo-box__option-item[aria-selected="true"]'
      );
    }

    if (selectedOption?.value === 'toggle-ring-size-inquiry') {
      e.preventDefault();
      e.stopImmediatePropagation();
      modal.classList.remove('hidden');
    }
  });

  // Close modal
  [closeModalBtn, overlay].forEach(el => {
    el?.addEventListener('click', () => modal.classList.add('hidden'));
  });
}

function initRingSizeSelector() {
  document.addEventListener("click", function (event) {
    const wrapper = event.target.closest(".ring-size-field-wrapper");
    if (!wrapper) return;

    const optionBtn = event.target.closest(".combo-box__option-item");
    if (!optionBtn) return;
    console.log('clicked option: ', optionBtn);
    const allOptions = wrapper.querySelectorAll(".combo-box__option-item");
    allOptions.forEach(option => {
      option.setAttribute("aria-selected", "false");
    });

    optionBtn.setAttribute("aria-selected", "true");

    let displayText;
    if (optionBtn.value === "toggle-ring-size-inquiry") {
      displayText = optionBtn.textContent.trim();
    } else {
      displayText = optionBtn.value || optionBtn.textContent.trim();
    }

    const selectedValueEl = wrapper.querySelector(".select__selected-value");
    if (selectedValueEl) {
      selectedValueEl.textContent = displayText;
    }
  });
}

function initRingSizeInquiryIntercept() {
  document.addEventListener("click", function (event) {
    const wrapper = event.target.closest(".ring-size-field-wrapper");
    if(!!wrapper) return;
    const optionWrapper = event.target.closest('.select-wrapper');
    if (!optionWrapper) return;
    const optionList = event.target.closest(".combo-box__option-list");
    if (!optionList) return;
    const optionBtn = event.target.closest(".combo-box__option-item");
    if (!optionBtn) return;

    if (optionBtn.value === "toggle-ring-size-inquiry") {
      event.preventDefault();
      event.stopImmediatePropagation();
      console.log(optionWrapper);
      const selectedValueEl = optionWrapper.querySelector(".select__selected-value");
      console.log('selected value', selectedValueEl);
      if (selectedValueEl) {
        selectedValueEl.textContent = optionBtn.textContent.trim();
      }
      
      optionList.querySelectorAll(".combo-box__option-item").forEach(item => {
        item.setAttribute("aria-selected", item === optionBtn ? "true" : "false");
      });

      const hiddenInput = optionWrapper.querySelector("input[type='hidden']");
      if (hiddenInput) {
        hiddenInput.value = "toggle-ring-size-inquiry";
      }
      optionWrapper.querySelector('.combo-box').removeAttribute('open');
    }
  }, true);
}

document.addEventListener("variant:changed", (event) => {
  const variant = event.detail.variant;
  if(!variant) return;
  const modal = document.querySelector('#ringSizeInquiryModal');
  const skuText = modal.querySelector('.product-sku');
  const skuValue = modal.querySelector("[name='contact[product_sku]'");
  const newSku = variant.sku;
  skuText.textContent = newSku;
  skuValue.value = newSku;
})

document.addEventListener('DOMContentLoaded', setupSwatchLabelHover);
document.addEventListener('variant:changed', setupSwatchLabelHover);
document.addEventListener('DOMContentLoaded', setupRingSizeInquiryDelegated);
document.addEventListener('variant:changed', setupRingSizeInquiryDelegated);
document.addEventListener("DOMContentLoaded", initRingSizeSelector);
document.addEventListener("variant:changed", initRingSizeSelector);
document.addEventListener("DOMContentLoaded", initRingSizeInquiryIntercept);
document.addEventListener("variant:changed", initRingSizeInquiryIntercept)
